export const VISUAL_LANGUAGE_ROLE_PROPERTY = 'malkaVisualRole';
export const VISUAL_LANGUAGE_ROLE_MESSAGE = 'malka-vrs:visual-role';
export const VISUAL_LANGUAGE_ASL_QUALITY_FLOOR = 720;
export const VISUAL_LANGUAGE_GUEST_THUMBNAIL_QUALITY = 360;
export const VISUAL_LANGUAGE_SMALL_ROOM_PARTICIPANT_LIMIT = 4;
export const VISUAL_LANGUAGE_INTERPRETER_FOCUS_PARTICIPANT_LIMIT = 8;
/**
 * Deaf-to-deaf group calls (p2p rooms) of this many people or more cap every
 * tile at 360p/30fps and keep only the active or pinned signer at the ASL
 * floor: eight 720p streams per receiver is more than most home uplinks and
 * laptops decode, and a 240-pixel-tall tile gains nothing from 720p.
 */
export const VISUAL_LANGUAGE_GROUP_TILE_CAP_PARTICIPANTS = 5;
export const VISUAL_LANGUAGE_GROUP_TILE_QUALITY = 360;
export const VISUAL_LANGUAGE_GROUP_TILE_FRAME_RATE = 30;
